/**
 * @returns {string}
 */
export const users = () => `users`;

/**
 * @param {string} userId
 * @returns {string}
 */
export const user = (userId) => `${users()}/${userId}`;
